
import gql from 'graphql-tag'
export default gql`
    query ViLabelsByFilmSummary ($from: Date, $to: Date, $noCache: Boolean) {
      ViLabelsByFilmSummary (from: $from, to: $to, noCache: $noCache) {
        filmCount
        masterCount
        labelCount
        durationSum
      }
    }
  `